// src/pages/CampaignDashboard/modals/SetupMeetingModal.js

import React, { useState } from 'react';

const SetupMeetingModal = ({ isOpen, onClose, onConfirm }) => {
    const [calendlyLink, setCalendlyLink] = useState("");

    if (!isOpen) return null;

    const handleConfirmClick = () => {
        onConfirm(calendlyLink);
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white w-[500px] p-6 rounded-lg shadow-lg">
                <h2 className="text-xl font-bold mb-4">Set Up Meeting Link</h2>
                <h3 className="text-gray-700 mb-4">
                    Please create your meeting link in Calendly and put your link here.
                </h3>
                <textarea
                    value={calendlyLink}
                    onChange={(e) => setCalendlyLink(e.target.value)}
                    placeholder="Enter your Calendly link"
                    className="w-full h-[100px] px-3 py-2 border rounded-lg resize-none"
                />
                <div className="flex justify-end space-x-4 mt-4">
                    <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded-full">
                        Cancel
                    </button>
                    <button onClick={handleConfirmClick} className="px-4 py-2 bg-blue-600 text-white rounded-full">
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SetupMeetingModal;